import * as React from "react";
import * as moment from "moment";
import { RioInput, RioConfirmModal, RioValidator, RioResources, RioIconButton, RioApiPost, RioApiGet, RioIf, RioExpandingPanel, RioModal, RioDateHelpers, RioDatePicker} from "rio.react.all";
import { RouteComponentProps } from "react-router";
import { RouteHelper } from "../helpers/RouteHelper";
import { ErrorModal } from "./ErrorModal";
import { WarehouseClosureApiModel } from "../apiModels/WarehouseClosureApiModel";

interface IWarehouseClosuresEditorModalProps extends Partial<RouteComponentProps>{
	data: WarehouseClosureApiModel;
	onClose: () => void;
}

interface IWarehouseClosuresEditorModalState {
	id: number;
	name: string;
	dateFrom: string;
	dateTo: string;
    closeClicked: boolean;
    responseError: string;
	changesMade: boolean;
}

export class WarehouseClosuresEditorModal extends React.Component<IWarehouseClosuresEditorModalProps, IWarehouseClosuresEditorModalState> {
    constructor(props: Readonly<IWarehouseClosuresEditorModalProps>) {
        super(props);

		this.state = {
			id: this.props.data.warehouseClosuresID ?? 0,
			name: this.props.data.name,
			dateFrom: this.props.data.dateFrom,
			dateTo: this.props.data.dateTo,
            closeClicked: false,
            responseError: null,
			changesMade: false,
        }
    }

	private validator = new RioValidator();
	private dateFromPicker = React.createRef<RioDatePicker>();
	private dateToPicker = React.createRef<RioDatePicker>();

    render() {
        return (
			<RioModal visible={true} onCancel={() => this.handleCloseClicked()} className="small" backgroundClickDisabled={true}>
				<RioExpandingPanel resource={RioResources.find("WarehouseClosures")} expandedDefault={true} disableToggle={true}>
					<div className="form-row warehouse-closure">
						<label className="warehouse-closure-label">{RioResources.find("WarehouseClosureName").text}<span className="required">*</span></label>
						<RioInput name="Name" type="text" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} validator={this.validator} validations={{ required: true, maxLength: 250 }} className="warehouse-closure-input" />
					</div>

					<div className="form-row warehouse-closure">
						<label className="warehouse-closure-label">{RioResources.find("DateFrom").text}<span className="required">*</span></label>
						<RioDatePicker
							ref={this.dateFromPicker}
							name="dateInput"
							validator={this.validator}
							validations={{ required: true }}
							from={this.props.data.dateFrom}
							onChange={(from: string, to: string) => { this.setState({ dateFrom: from }) }}
							asUtc={true}
							nullable={true}
							time={false}
							range={false}
							disabled={!!this.props.data.warehouseClosuresID}
							dateFormat={"DD/MM/YYYY"} />
					</div>
					<div className="form-row warehouse-closure">
						<label className="warehouse-closure-label">{RioResources.find("DateTo").text}<span className="required">*</span></label>
						<RioDatePicker
							ref={this.dateToPicker}
							name="dateInput"
							validator={this.validator}
							validations={{ required: true }}
							from={this.props.data.dateTo}
							onChange={(from: string, to: string) => { this.setState({ dateTo: from }) }}
							asUtc={true}
							nullable={true}
							time={false}
							range={false}
							disabled={!!this.props.data.warehouseClosuresID}
							dateFormat={"DD/MM/YYYY"} />
					</div>
				</RioExpandingPanel>

				<div className="buttons">
					<RioIconButton resource={RioResources.find("Save")} onClick={() => this.handleSaveClicked()} hasPermission={true} />
					<RioIconButton resource={RioResources.find("Close")} onClick={() => this.handleCloseClicked()} hasPermission={true} />
				</div>

				<RioIf condition={!!this.state.responseError} then={
					<ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
				} />

            </RioModal>
        );
	}

	handleNameChanged(value: string) {
		this.setState({
			name: value,
		})
	}

	handleSaveClicked() {
		let item: WarehouseClosureApiModel = {
			warehouseClosuresID: this.state.id,
			name: this.state.name,
			dateFrom: this.state.dateFrom,
			dateTo: this.state.dateTo
		};

		RioApiPost.asPromise<number>("/api/WarehouseClosures/AddUpdate", item)
			.then(response => {
				if (!!response) {
					this.setState({
						id: response,
					});
					this.props.onClose();
				}
			})
			.catch((response) => {
				this.validator.addModelErrors(this, response.errors);
			});
	}

	handleCloseClicked() {
		this.props.onClose();
	}

}
